<template>
  <div id="detail" v-loading="loading" style="height:100%">
    <err-page v-if="errType" :errType="errType" @press="receiveAppData" :message="message"></err-page>
    <!-- {{receivedata}} -->
    <div v-else>
      <div class="content-wrap">
        <p class="content-title">{{detail.permissionProblem}}</p>
        <pre><p class="descript">{{detail.permissionDesc}}</p></pre>
      </div>
      <div class="content-wrap">
        <div class="title-wrap">
          <p class="content-title">{{detail.position1.titleName}}</p>
          <div class="content-set" v-if="detail.position1.isJump" @click="handleSet">
            <span class="set">去设置</span>
            <img src="@/assets/next-blue.png" alt="" width="20px" height="20px" />
          </div>
        </div>
        <pre><p class="descript">{{detail.position1.configDesc}}</p></pre>
      </div>
      <div class="content-wrap">
        <div class="title-wrap" @click="handleToggle">
          <p class="content-title">{{detail.position2.titleName}}</p>
          <img v-if="visible" src="@/assets/up.png" alt="" width="20px" height="20px" />
          <img v-else src="@/assets/down.png" alt="" width="20px" height="20px" />
        </div>
        <pre><p class="descript" v-show="visible">{{detail.position2.configDesc}}</p></pre>
      </div>
      <div class="content-wrap" v-if="detail.privacyConfig">
        <p @click="handleGoPrivacy" class="set">
          {{detail.privacyConfig.protocolTitle}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { formatTimeFull, handleSign, urlEncode, handleParams } from '@/utils.js';
import ErrPage from '@/components/err-page.vue';

export default {
  name: 'detail',
  components: { ErrPage },
  data() {
    return {
      loading: true,
      visible: false,
      detail: {
        position1: {},
        position2: {},
      },
      errType: null,
      message: '',
      // receivedata: null,
    };
  },
  methods: {
    handleToggle() {
      this.visible = !this.visible;
    },
    handleGoPrivacy() {
      this.$bridge.callHandler(
        'jumpToPrivacyDetialPage',
        {
          title: this.detail.privacyConfig.protocolTitle,
          url: this.detail.privacyConfig.protocolAddress,
        },
        (data) => {
          console.log(data);
        }
      );
    },
    handleSet() {
      window.WebViewJavascriptBridge.callHandler(
        'jumpToPermitSetting',
        {keyList: localStorage.getItem("keyList")},
        (data) => {
          console.log(data);
        }
      );
    },
    handleGetList(dataParams) {
      const time = formatTimeFull(new Date(), '', '');
      const headersParams = {
        "method": "guahao.perm.sdk.detail",
        "appkey": dataParams.appkey,
        "timestamp": time,
      };
      const url = this.$store.state.openUrl;
      axios({
        method: 'post',
        url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
          "sign": handleSign({ ...headersParams, ...dataParams }),
          ...headersParams,
        },
        data: urlEncode(dataParams),
      }).then(res => {
        if (res.data.code === '0') {
          if (!res.data.data) {
            this.errType = 'emptydata';
            return;
          }
          this.errType = null;
          const data = res.data.data;
          const position1 = data.rigidList.find(item => item.showPosition === 1);
          const position2 = data.rigidList.find(item => item.showPosition === 2);
          this.detail = data;
          this.detail.position1 = position1;
          this.detail.position2 = position2;
        } else {
          this.errType = 'request';
          this.message = res;
        }
      }).catch((res) => {
        this.message = res;
        this.errType = 'internet';
      }).finally(() => {
        this.loading = false;
      });
    },
    receiveAppData() {
      //参数一：调用java中的方法   submitFromWeb是方法名，必须和Android中注册时候的方法名称保持一致
      //参数二：返回给Android端的数据，可以为字符串，json等信息
      //参数三：js接收到Android传递过来的数据之后的相应处理逻辑
      this.$bridge.callHandler(
        'gainAppConfig',
        {'param': "detail页成功接收到数据---"},
        (data) => {
          const params = handleParams(data);
          this.handleGetList(params);
        }
      );
    },
    connectWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge)
      } else {
        document.addEventListener(
          'WebViewJavascriptBridgeReady'
          , function() {
            callback(window.WebViewJavascriptBridge)
          },
          false
        );
      }
    }
  },
  created() {
    // const str = 'XSv4qxUMpkEy8nFm1XO9nx67bc5l5iIZxof7V6vxHm/HiPSaT2nCyxmfV9ifWhR0/Z5Y9kWQvREuC/yoePAqlUQS45OzlzMuy5+ihmZlIWhy0SYeiUJanIqt+hRoEe4EX+9HnjXBgf02moA4tXX6vA==';
    // const str = 'JyscrUjXNsb0At86Jsqc5zJ3u9vN1YwkC36qO354X+KjI0GAlv7z/bjDH+kuTn6LI2V0jz4NdAJhpYe9l4S0cJn8p6BqHDcuLyR5bSdnwFD7wm5/tJi7SomFT4rigRpQ5ULJsHI4cpE+O5rqhWtZUYYxqjaPFsi1JBG9oFHRLXVKmCmjWoJ8Dczicfgna8eXxMx+yVPkOGFnlq7O1BDB7w==';
    // console.log(handleParams(str));
    // this.handleGetList(handleParams(str));
    // this.handleGetList({clientId: '123',clientType: 2,clientVersion: '123',permissionGroupId: 1, appkey: '37086251', appsecret:'24D5051E3A06B12743741203CFDD33B4'});
    this.connectWebViewJavascriptBridge(function(bridge) {
        //初始化
      bridge.init(function(message, responseCallback) {
        var data = {
          'Javascript Responds': 'Wee!'
        };
        responseCallback(data);
      });
    })
    this.receiveAppData();
  },
};
</script>

<style scoped>
#detail {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header {
  width: 100%;
  height: 70px;
  background: #f8f8f8;
  text-align: center;
  vertical-align: middle;
  line-height: 70px;
}
.header img{
  position: absolute;
  left: 10px;
  top: 25px;
}
.title {
  font-size: 18px;
  color: #434343;
}
.content-wrap {
  padding: 20px;
  margin-bottom: 10px;
  background: #fff;
}
.title-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.content-title {
  flex: 1;
}
/* .li-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #eeeeee;
} */
.content-set {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 70px;
}
.set {
  font-size: 14px;
  /* color: #337afd; */
  color: #555fef;
}
.open {
  font-size: 14px;
  color: #b9b9b9;
}
pre{
white-space: pre-wrap;           /* css-3 */
white-space: -moz-pre-wrap;      /* Mozilla, since 1999 */
white-space: -pre-wrap;          /* Opera 4-6 */
white-space: -o-pre-wrap;        /* Opera 7 */
word-wrap: break-word;           /* Internet Explorer 5.5+ */
}
</style>
